import $ from 'jquery'

export default function () {

    $(document).ready(function () {

        formSubmitOnClick();

    });

    let formSubmitOnClick = () => {
        $('[data-form-submit-on-click]').on('click', function () {
            let formId = $(this).data('form-submit-on-click')
            if( ! formId ) return;

            formId = (formId.startsWith('#')) ? formId.substring(1) : formId;
            // console.log(formId) test
            // console.log($.trim(formId, '#'))

            $(`#${formId}`).submit()
        });
    }
}
